import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';

@Component({
  selector: 'app-mz-form-scheduling',
  templateUrl: './mz-form-scheduling.component.html',
  styleUrls: ['./mz-form-scheduling.component.scss']
})
export class MzFormSchedulingComponent extends GridBaseCase {
  selectValue="";
  constructor() { super(); }

  changeSelect($event){

  }
}
